//
const addressKey = "yingqiyu_ziubao_shop_user_address";

export const setAddress = (address) => {
    localStorage.setItem(addressKey, JSON.stringify(address));
}

export const getAddress = () => {
    let address = localStorage.getItem(addressKey);
    if(address)
    {
        return JSON.parse(address);
    }
}

//
const customerAddressListKey = "yingqiyu_ziubao_shop_customer_address_list";

export const setCustomerAddressList = (address) => {
    localStorage.setItem(customerAddressListKey, JSON.stringify(address));
}

export const getCustomerAddressList = () => {
    let address = localStorage.getItem(customerAddressListKey);
    if (address) {
        return JSON.parse(address);
    }
}

//
const defaultAddressKey = "yingqiyu_ziubao_shop_default_address";

export const setDefaultAddress = (address) => {
    localStorage.setItem(defaultAddressKey, JSON.stringify(address));
}

export const getDefaultAddress = () => {
    let address = localStorage.getItem(defaultAddressKey);
    if (address) {
        return JSON.parse(address);
    }
}